import { isEqual } from "lodash";

import { useMemo } from "react";

import { useFilterContext } from "../FilterContext";
import { FilterData } from "../typing";
import { getOptionCheckedText, getRadioCheckedText } from "../utils";

/**
 * 用于回显选中的filterButton
 * @returns
 */
const useFilterChecked = () => {
  const { filterData, filterOptions, defaultFilterData } = useFilterContext();
  return useMemo(() => {
    const filterCheckedMap: Record<string, string> = {};

    const isDefault = (key: keyof FilterData) => {
      return isEqual(defaultFilterData[key], filterData[key]);
    };

    const filterOptionsMap = {
      programs: filterOptions.programsOptions,
      banks: filterOptions.banksOptions,
      cabins: filterOptions.cabinsOptions,
      nonStop: filterOptions.cabinsOptions,
      lastSeenTime: filterOptions.lastSeenRangeTime,
    };

    for (const key of Object.keys(filterData)) {
      switch (key) {
        case "programs":
        case "cabins":
        case "nonStop":
        case "banks": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getOptionCheckedText(filterOptionsMap[key], filterData[key]);
          break;
        }

        case "tax":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: $${filterData[key]}`;
          break;

        case "maxPoints":
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : `${key}: ${Math.ceil(filterData[key] / 1000)}K`;
          break;

        case "seats":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: ${filterData[key]}+`;
          break;

        case "premium":
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: >=${filterData[key]}%`;
          break;

        case "lastSeenTime":
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getRadioCheckedText(filterOptionsMap[key], filterData[key]);
          break;

        default:
          break;
      }
    }

    return filterCheckedMap;
  }, [filterData, filterOptions, defaultFilterData]);
};

export default useFilterChecked;
